import { useTranslation } from 'react-i18next';
import type { NoticeCategory } from '@/hooks/useNotices';

interface ChipDef {
  key: NoticeCategory;
  labelKey: string;
  dotColor?: string;
}

const CHIPS: readonly ChipDef[] = [
  { key: 'all', labelKey: 'notices.cat_all' },
  { key: 'important', labelKey: 'notices.cat_important', dotColor: 'var(--status-alert)' },
  { key: 'general', labelKey: 'notices.cat_general', dotColor: 'var(--primary)' },
  { key: 'hr', labelKey: 'notices.cat_hr', dotColor: 'var(--status-complete)' },
  { key: 'safety', labelKey: 'notices.cat_safety', dotColor: 'var(--status-pending)' },
];

interface NoticeFilterProps {
  current: NoticeCategory;
  onChange: (cat: NoticeCategory) => void;
}

export function NoticeFilter({ current, onChange }: NoticeFilterProps) {
  const { t } = useTranslation();
  return (
    <div className="notice-filter" role="tablist">
      {CHIPS.map((chip) => (
        <button
          key={chip.key}
          type="button"
          role="tab"
          aria-selected={current === chip.key}
          className={current === chip.key ? 'notice-chip active' : 'notice-chip'}
          data-cat={chip.key}
          onClick={() => onChange(chip.key)}
        >
          {chip.dotColor && (
            <span className="notice-chip-dot" style={{ background: chip.dotColor }} />
          )}
          {t(chip.labelKey)}
        </button>
      ))}
    </div>
  );
}
